/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const audiobookPages = {
    AudiobookCategoryPage: () => import('@/audiobook/AudiobookCategoryPage'),
    AudiobookDetailPage: () => import('@/audiobook/AudiobookDetailPage'),
    AudiobooksHomePage: () => import('@/audiobook/AudiobooksHomePage'),
}
